export default __webpack_public_path__ + "static/1-d16fe23d39d51f74de7b5dd403218842.jpg";